class Doctor {
  constructor(container) {
    this.updateHealth = this.updateHealth.bind(this)
    this.container = container
    this.problems = []
    this.updateHealth()
  }

  addProblem(problem) {
    this.problems.push(problem)
    return this.updateHealth()
  }

  healthy() {
    return this.problems.length === 0
  }

  clearProblems() {
    return (this.problems = [])
  }

  updateHealth() {
    let status
    let text
    if (!$(this.container).length) {
      return
    }
    setTimeout(this.updateHealth, 3000)

    const $health = $('.js-viewer-health')
    const classes = 'is-viewer-good is-viewer-bad'
    if (!this.problems.length) {
      text = 'Everything running smoothly!'
      status = 'is-viewer-good'
    } else {
      text = this.problems.join(', ')
      status = 'is-viewer-bad'
      $health.show()
    }

    $health.removeClass(classes)
    $health.addClass(status)
    return $health.find('.js-message').html(text)
  }
}

export default Doctor
